import { Component } from '@angular/core';
import { NavController,ViewController, ModalController } from 'ionic-angular';
import { LoadingProvider } from '../../providers/loading/loading';
import { ConfigProvider } from '../../providers/config/config';
import { Http } from '@angular/http';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Platform } from 'ionic-angular';
import { LoginPage } from '../login/login';
import swal from 'sweetalert';
import { HomePage } from '../home/home';
import { CreateSubAccountsPage } from '../create-subaccount/create-subaccount';

@Component({
  selector: 'page-subscriptions',
  templateUrl: 'subscriptions.html',
})
export class SubscriptionsPage {
  httpRunning = true;
    subscription = new Array;
  image;
  errorMessage = '';
  constructor(
    public http: Http,
    public navCtrl: NavController,
    public config: ConfigProvider,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public loading: LoadingProvider,
    public shared: SharedDataProvider,
    public platform: Platform,
    private camera: Camera
  ) {
  }

  ionViewDidEnter() {
    this.getSubscriptions();
    console.log("Customer info:",this.shared.customerData);

}




cancelSub(){

  this.loading.show();
  var data: { [k: string]: any } = {};
  data.sub_id = this.shared.customerData.stripe_sub;

  this.http.post(this.config.url + 'cancelSubcriptions', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    this.httpRunning = false;
    //$rootScope.address=response.data.data;
    if (data.success == 1) {
      console.log("Subscriptions:",data.data);
      this.subscription = data.data;
      swal({title: "Success!",text: "Subscription was cancelled. If you are due a refund it will be processed shortly.",icon: "success"}).then((value) => {
          //this.navCtrl.push(HomePage);
      this.loading.hide();
      this.navCtrl.popToRoot();
          //this.shared.login(data.data[0]);
      });

    }
    // $scope.$broadcast('scroll.refreshComplete');
  },
    function (response) {
      this.loading.hide();
      this.alert.show("Server Error while Loading Orders");
      //console.log(response);
    });

}


  getSubscriptions() {
    this.httpRunning = true;
    this.subscription = [];

    this.loading.show();
    var data: { [k: string]: any } = {};
    data.sub_id = this.shared.customerData.stripe_sub;
    data.cus_id = this.shared.customerData.stripe_cus;
    this.http.post(this.config.url + 'getSubcriptions', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      this.httpRunning = false;
      //$rootScope.address=response.data.data;
      if (data.success == 1) {
        console.log("Subscriptions:",data.data);
        this.subscription = data.data;
      }
      // $scope.$broadcast('scroll.refreshComplete');
    },
      function (response) {
        this.loading.hide();
        this.alert.show("Server Error while Loading Orders");
        //console.log(response);
      });
  };


  dismiss() {
    this.viewCtrl.dismiss();
    let modal = this.modalCtrl.create(LoginPage);
    modal.present();
  }
  // ionViewDidLoad() {
  //   console.log('ionViewDidLoad SignUpPage');
  // }
}



// WEBPACK FOOTER //
// ./src/pages/subscriptions/subscriptions.ts